import { Application, Container } from "pixi.js";

export const viewport = (
  container: Container,
  target: Container,
  app: Application,
) => {
  let offsetX = 0;
  let offsetY = 0;
  app.ticker.add(() => {
    const screenX = target.x + offsetX;
    const screenY = target.y + offsetY;

    if (screenX < 200) {
      offsetX += 200 - screenX;
    }
    if (screenY < 200) {
      offsetY += 200 - screenY;
    }
    if (screenX > app.screen.width - 200) {
      offsetX += app.screen.width - 200 - screenX;
    }
    if (screenY > app.screen.height - 200) {
      offsetY += app.screen.height - 200 - screenY;
    }
    container.updateTransform({ x: offsetX, y: offsetY });
  });
};
